import { GraphQLErrorCode } from '@this+that/constants';
import {
  ApprovalDecision,
  BrainReviewDecision,
  BrainReviewState,
} from '@this+that/models';

import { getGraphQLErrorCode } from '../../utils/graphqlErrors';

export const BRAIN_REVIEW_DECISION_BY_APPROVAL: Record<
  ApprovalDecision,
  BrainReviewDecision
> = {
  [ApprovalDecision.APPROVED]: BrainReviewDecision.APPROVED,
  [ApprovalDecision.REJECTED]: BrainReviewDecision.REJECTED,
};

export const BRAIN_REVIEW_STATE_BY_APPROVAL: Record<
  ApprovalDecision,
  BrainReviewState
> = {
  [ApprovalDecision.APPROVED]: BrainReviewState.APPROVED,
  [ApprovalDecision.REJECTED]: BrainReviewState.REJECTED,
};

const BRAIN_REVIEW_ERROR_KEY_BY_CODE: Partial<
  Record<GraphQLErrorCode, string>
> = {
  [GraphQLErrorCode.FORBIDDEN]: 'doBox.brainReview.notEligible',
  [GraphQLErrorCode.UNAUTHORIZED]: 'doBox.brainReview.notEligible',
  [GraphQLErrorCode.CONFLICT]: 'doBox.brainReview.alreadyDecided',
  [GraphQLErrorCode.NOT_FOUND]: 'doBox.brainReview.notFound',
};

const BRAIN_REVIEW_GENERIC_ERROR_KEY = 'doBox.brainReview.respondError';

export function resolveBrainReviewErrorKey(error: unknown): string {
  const code = getGraphQLErrorCode(error);
  return (
    (code && BRAIN_REVIEW_ERROR_KEY_BY_CODE[code]) ??
    BRAIN_REVIEW_GENERIC_ERROR_KEY
  );
}
